<template>
    <Layout>
        <PageHeader :title="title" />

        <form class="card" @submit.prevent="modifyPaymentMethod">
            <div class="row col-xl-12 card-body" v-if="!isLoading">
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="first_name" class="form-label">نام</label>
                        <input type="text" class="form-control" id="first_name" placeholder="نام شما" v-model="profile.fname" readonly>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="last_name" class="form-label">نام خانوادگی</label>
                        <input type="text" class="form-control" id="last_name" placeholder="نام خانوادگی شما" v-model="profile.lname" readonly>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="bank_name" class="form-label">بانک</label>
                        <input type="text" class="form-control" id="bank_name" v-model="bank_name" placeholder="بانک حساب شما">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="account_number" class="form-label">شماره حساب</label>
                        <input type="text" class="form-control" id="account_number" v-model="account_number" placeholder="شماره حساب">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="card_number" class="form-label">شماره کارت</label>
                        <input type="text" class="form-control" id="card_number" v-model="card_number" placeholder="شماره کارت">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="sheba_number" class="form-label">شماره شبا</label>
                        <input type="text" class="form-control" id="sheba_number" v-model="sheba_number" placeholder="شماره شبا حساب شما">
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="hstack gap-2 justify-content-end">
                        <button type="submit" class="btn btn-primary"> ثبت تغییرات </button>
                    </div>
                </div>

                <!-- end card -->
            </div>

            <div class="row col-xl-12 card-body" v-else>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="first_name" class="form-label">نام</label>
                        <input type="text" class="form-control" id="first_name" placeholder="نام شما" v-model="profile.fname" readonly>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="last_name" class="form-label">نام خانوادگی</label>
                        <input type="text" class="form-control" id="last_name" placeholder="نام خانوادگی شما" v-model="profile.lname" readonly>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="bank_name" class="form-label">بانک</label>
                        <Skeletor width="100%;display: block;" />
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="account_number" class="form-label">شماره حساب</label>
                        <Skeletor width="100%;display: block;" />
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="card_number" class="form-label">شماره کارت</label>
                        <Skeletor width="100%;display: block;" />
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label for="sheba_number" class="form-label">شماره شبا</label>
                        <Skeletor width="100%;display: block;" />
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="hstack gap-2 justify-content-end">
                        <Skeletor width="100%;display: block;" />
                    </div>
                </div>

                <!-- end card -->
            </div>

            <!-- end col -->
        </form>
    </Layout>
</template>

<script>
import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";
import PageHeader from "@/components/page-header";
import { authGetters } from "@/state/helpers";
import UserService from "@/services/user.service";
import { Skeletor } from "vue-skeletor";

export default {
    name: "payment-methods.vue",

    data() {
        return {
            title: "اطلاعات بانکی",
            bank_name: '',
            account_number: '',
            card_number: '',
            sheba_number: '',
            isLoading: true,
        };
    },
    page: {
        title: "حساب بانکی",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    computed: {
        ...authGetters,
        profile() {
            return this.getUser;
        },
    },
    created() {
        this.fetchPromises();
    },
    methods: {
        modifyPaymentMethod() {
            return new Promise((resolve) => {
                this.profileIsUpdating = true;
                UserService.vendorUpdatePaymentMethod(this.bank_name, this.account_number, this.card_number, this.sheba_number)
                    .then((response) => {
                        console.log(response);
                        resolve(response);
                        this.$notify({
                            title: response.data.message,
                            type: 'success',
                        });
                    }, (error) => {
                        this.$notify({
                            title: "خطا",
                            text: error.message,
                            type: 'error',
                        });
                    })
                    .then(() => {
                        this.isLoading = false;
                    });
            });
        },
        fetchPaymentData() {
            return UserService.vendorGetPaymentMethod()
                .then((response) => {
                    if(response.status !== 200) {
                        this.isLoading = false;
                        return;
                    }
                    const {data} = response;
                    const {bank_name, account_number, card_number, sheba_number} = data;
                    this.bank_name = bank_name;
                    this.account_number = account_number;
                    this.card_number = card_number;
                    this.sheba_number = sheba_number;
                    this.isLoading = false;
                    // this.productsData = data.data;
                });
        },
        fetchPromises() {
            this.isTransactionsLoading = true;
            Promise.all([
                this.fetchPaymentData(),
            ])
        },
    },
    components: {
        Layout,
        PageHeader,
        Skeletor
    },
}
</script>

<style scoped>

</style>
